import { useQueryParams } from '@/hooks';
import usePagination from '@/hooks/usePagination';
import { useEffect } from 'react';

const useShippingsPagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize:
        Number(getQueryParam('pageSize')) ||
        Number(localStorage.getItem('shippings_pageSize')) ||
        100,
    });

  useEffect(() => {
    setQueryParams({
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    });
  }, [currentPage, pageSize]);

  return {
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange: (newPageSize: number) => {
      localStorage.setItem('shippings_pageSize', newPageSize.toString());
      handlePageSizeChange(newPageSize);
    },
  };
};

export default useShippingsPagination;
